import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import CircularProgress from '../useful/CircularProgress'
import { imageAddress } from '../../utils/useful'

export default class WorkLoadHorizontal extends Component {
    state = {
        tooltip: false,
        collapse: false,
        active: false,
        open: false,
        workload: [
            { src: '/images/video/vid1.jpg', bgimg: '/images/shape.png', name: 'Sara Mohammadi', progress: '30%' },
            { src: '/images/video/vid2.jpg', bgimg: '/images/shape.png', name: 'Aqdas Mirza', progress: '70%' },
            { src: '/images/video/vid3.jpg', bgimg: '/images/shape.png', name: 'Ali Salar', progress: '5%' },
            { src: '/images/video/vid4.jpg', bgimg: '/images/shape.png', name: 'MohammadReza Anguti', progress: '43%' },
            { src: '/images/video/vid5.jpg', bgimg: '/images/shape.png', name: 'Ho3ein Morshedi', progress: '98%' },
            { src: '/images/video/vid6.jpg', bgimg: '/images/shape.png', name: 'Ali Panahi', progress: '43%' },
            { src: '/images/video/vid7.jpg', bgimg: '/images/shape.png', name: 'Mina Mahmoodi', progress: '62%' },
        ],
        taskprogress: [
            { taskname: 'front', width: '40%', color: '#00A4bb' },
            { taskname: 'back', width: '5%', color: 'red' },
            { taskname: 'voice', width: '28%', color: 'green' },
            { taskname: 'video call', width: '15%', color: 'purple' },
            { taskname: 'chat profile', width: '12%', color: 'yellow' },
        ]

    }
    handleCollapse = (index) => {
        if (this.state.collapse == index) {
            this.setState({ active: !this.state.active })
        } else {
            this.setState({ collapse: index, active: true })
        }
    }
    render() {
        return (
            <div className='dashboard-widgets p-3 w-100'>

                <div className="mb-4">
                    <p className='text-bold text-semibig '>Workload</p>
                    <div className="flexc mt-1">
                        <div className="mrd-2 flexcc">
                            <img className="br-20" src={imageAddress('', 'profile')} style={{ height: 20, width: 20, objectFit: 'cover' }} />
                        </div>
                        <div className="flex-1 flexc">
                            <p className='text-smaller '>Applet Name</p>
                        </div>
                    </div>
                </div>

                


                {this.state.workload.map((prop, index) => {
                    return (
                        <div className='' key={index}>
                            <div onMouseOver={() => this.setState({ tooltip: !this.state.tooltip })} className='mb-2 flexc'>
                                <div className='br-100 mrd-4' style={{ width: '50px', height: '50px' }}>
                                    <img className='w-100 profile-img' src={prop.src} alt="profile" />
                                </div>
                                <div className='cursor-pointer br-5 mb-2 tooltip' style={{ position: 'relative', width: '100%', borderBottom: "8px solid #E0E9CA" }}>
                                    <div className='flexcb' onClick={() => this.handleCollapse(index)}>
                                        <p className='color-muted text-small'>{prop.name}</p>
                                        <img className='transition-all' style={{ transform: (this.state.collapse == index && this.state.active) ? "rotate(-180deg)" : "" }} width="15px" src="/images/arrowbottom.png" alt="" />
                                    </div>
                                    <div className='position-absolute transition-all br-10' style={{ width: prop.progress, borderBottom: '8px solid #62D54C' }}></div>
                                    <div className='tooltip-content'>
                                        <p className='text-smaller '>{prop.name}</p>
                                        <p>Progress : {prop.progress}</p>
                                    </div>
                                </div>
                            </div>
                            <Collapsible open={(this.state.collapse == index && this.state.active)}>
                                {/* style={{ backgroundImage: 'url(' + prop.bgimg + ')', backgroundPosition: "top", backgroundSize: "contain", backgroundRepeat: 'no-repeat' }} */}
                                <div className='m-4 mrd-2 p-4 box-shadow-widgets br-10'>
                                    <div className='flexc'>
                                        <div className='br-100 mrd-4' style={{ width: '50px', height: '50px' }}>
                                            <img className='w-100 profile-img' src={prop.src} alt="profile" />
                                        </div>
                                        <p className='fw-600 color-black'>{prop.name}</p>
                                    </div>
                                    {/* <div className='mx-auto my-2' style={{ borderBottom: "1px solid #4f4f4f", width: '80%' }} /> */}
                                    <div className='px-2'>
                                        {/* <p>TO DO : 12</p>
                                        <p>DONE : 3</p> */}
                                        <p className='text-small color-muted  my-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, dicta!</p>
                                        <div style={{ borderBottom: '1px solid #ebeaf2' }} className='flexcb mb-2 pb-2'>
                                            <div className='flexc'>
                                                <div className='mrd-4 text-center'>
                                                    <p>3</p>
                                                    <p>TO DO</p>
                                                </div>
                                                <div className='mld-4 text-center'>
                                                    <p>12</p>
                                                    <p>DONE</p>
                                                </div>
                                            </div>
                                            <CircularProgress size={70} strokeWidth={4} progress={30} />
                                        </div>
                                    </div>
                                    <div >
                                        <div style={{ borderBottom: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-3">
                                            <div>
                                                <p className='color-muted'>WorkLoad Task List</p>
                                            </div>
                                            <div>
                                                <p className='color-muted text-small'>Status</p>
                                            </div>
                                        </div>
                                        <div className="p-3" style={{ padding: '0 5%', background: '#fff' }}>
                                            <div className="d-flex">
                                                <p className='text-smaller' style={{ color: '#777' }}>layout finished</p>
                                                <p className='text-smaller' style={{ color: '#777' }}></p>
                                            </div>
                                            <div className='w-100 flexc br-10' style={{ height: '10px', overflow: 'hidden' }}>
                                                {this.state.taskprogress.map((item, index) => {
                                                    return (
                                                        <div key={index} style={{ background: item.color, width: item.width, height: '10px' }}>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                        <div style={{ borderTop: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-2">
                                            <button className="w-100">
                                                <p>TO DO</p>
                                                <p>3</p>
                                            </button>
                                            <div style={{ borderRight: '1px solid #ebeaf2' }} />
                                            <button className="w-100">
                                                <p>DONE</p>
                                                <p>12</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='flexcb cursor-pointer' onClick={() => this.setState({ open: !this.state.open })}>
                                            <p className='fw-600 color-muted'>Ready (2)</p>
                                            <img className='transition-all' style={{ transform: this.state.open ? "rotate(-180deg)" : "" }} width="15px" src="/images/arrowbottom.png" alt="" />

                                        </div>
                                        <Collapsible open={this.state.open}>
                                            <p className='text-small color-muted'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illum alias minus perferendis modi ipsum! Modi assumenda voluptas ea?</p>
                                        </Collapsible>
                                    </div>
                                </div>
                            </Collapsible>
                        </div>
                    )
                })}
            </div>
        )
    }
}
